/* sb-dc-tplfor.js — open the gallery on the product the customer came from.
   2026-09-04, fixed 2026-09-05.

   The picker and the editor's button pass ?for=<product>. Landing on all
   600-odd templates when you were just designing a round sticker is not help,
   so this picks that product in the gallery's own filter and lets the page do
   the rest.

   Two ways of matching, in order:

     1. The name as written. The picker sends the filter's own label, so
        "Custom Vinyl Banners" should simply select "Custom Vinyl Banners".
        Compared with punctuation and case flattened.
     2. Word overlap, for the editor's button, which sends a product handle:
        "8x8-fabric-pop-up-display-backdrop-banner-only" shares pop/up/display/
        backdrop with "Pop-Up Display Backdrop" and little with the rest.

   Why both: the overlap test alone got "Custom Vinyl Banners" and "Fabric
   Banners" wrong. It ignores common words — custom, banner, banners — to stop
   every banner product matching every other, which left those two labels with
   a single distinguishing word each (vinyl, fabric) and a score under the
   threshold, so the gallery opened unfiltered.

   A weak match is still left alone: showing everything is a fine outcome,
   showing the wrong product is not.

   Diagnostics: window.__dcTplFor. */
(function () {
  'use strict';

  var MIN_SCORE = 2;      // at least two meaningful words in common
  var STOP = { the: 1, and: 1, for: 1, with: 1, only: 1, custom: 1, banner: 1, banners: 1 };

  function flat(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function words(s) {
    return flat(s).split(' ').filter(function (w) { return w.length > 1 && !STOP[w]; });
  }
  function score(handle, label) {
    var a = words(handle), b = words(label), n = 0;
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) >= 0) n++;
    return n;
  }

  function run() {
    var m = location.search.match(/[?&]for=([^&]+)/);
    if (!m) return true;                       // nothing asked for
    var want = decodeURIComponent(m[1].replace(/\+/g, ' '));

    var sel = document.querySelector('#sbdt-root select');
    if (!sel || sel.options.length < 2) return false;   // grid not up yet

    var out = { want: want, applied: false, how: null, best: null, score: 0 };
    window.__dcTplFor = out;

    /* 1. the label itself */
    var flatWant = flat(want), pick = -1;
    for (var i = 1; i < sel.options.length; i++) {
      if (flat(sel.options[i].text) === flatWant) { pick = i; out.how = 'exact'; break; }
    }

    /* 2. word overlap, for handles */
    if (pick < 0) {
      var best = -1, bestI = -1;
      for (var j = 1; j < sel.options.length; j++) {
        var s = score(want, sel.options[j].text);
        if (s > best) { best = s; bestI = j; }
      }
      out.score = best;
      if (best >= MIN_SCORE && bestI > 0) { pick = bestI; out.how = 'words'; }
    }

    if (pick > 0) {
      out.best = sel.options[pick].text;
      sel.selectedIndex = pick;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      out.applied = true;
    }
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    var done = false;
    try { done = run(); } catch (e) { done = true; }
    if (done || ++tries > 40) clearInterval(t);
  }, 300);
})();
